<template>
  <!-- followRecommend.vueのonMenuHideに反応するのをstopPropagationで防ぐ -->
  <button :class="[$style.button, isLiked && $style.isLiked]" @click.stop="onClick">
    <SvgIcon :svg="isLiked ? HeartFillSvg : HeartActiveSvg" :class="$style.heartIcon" />
    {{ itemStore.likedCounts[itemId] || 0 }}
  </button>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { likeItem, unlikeItem } from '@/js/lib/api/item';
import { useItemStore } from '@/js/lib/store/item';
import { useUserStore } from '@/js/lib/store/user';
import { loading } from '@/js/lib/ui';
import { signinSignup } from '@/js/lib/ui/signin-signup';
import SvgIcon from '@/js/components/molecules/SvgIcon.vue';
import HeartActiveSvg from '@/svgs/vue/heart-active.svg';
import HeartFillSvg from '@/svgs/vue/heart-fill.svg';

const props = defineProps<{
  itemId: number;
}>();
const userStore = useUserStore();
const itemStore = useItemStore();
const isLoading = ref(false);
const isLiked = computed(() => itemStore.likedItemIds.includes(props.itemId));
const like = async () => {
  itemStore.addLikedItemId(props.itemId);
  await likeItem({ itemId: props.itemId }).catch(() => {
    itemStore.removeLikedItemId(props.itemId);
  });

  window.dataLayer?.push({
    event: 'like',
    event_category: 'kpi',
    event_label: 'item',
  });
};
const unlike = async () => {
  itemStore.removeLikedItemId(props.itemId);
  await unlikeItem({ itemId: props.itemId }).catch(() => {
    itemStore.addLikedItemId(props.itemId);
  });
};
const onClick = async () => {
  if (userStore.isAuthenticated) {
    if (isLoading.value) {
      return;
    }

    isLoading.value = true;
    await (isLiked.value ? unlike() : like());
    isLoading.value = false;
  } else {
    signinSignup({
      next: window.location.href,
      callback: async () => {
        await loading({
          asyncFunc: async () => {
            await like();
            window.location.reload();
          },
          text: 'ログインしています',
        });
      },
    });
  }
};

onMounted(() => {
  itemStore.initLikedData([props.itemId]);
});
</script>

<style module lang="scss">
.button {
  align-items: center;
  background-color: transparent;
  border-style: none;
  color: $gray900;
  cursor: pointer;
  display: flex;
  font-size: 18px;
  gap: 4px;
  line-height: 1.6;
  text-decoration: none;

  @media (--sp) {
    font-size: 16px;
  }

  &:hover {
    opacity: 0.8;
  }

  .heartIcon {
    fill: #4b4b4b;
    width: 48px;

    @media (--sp) {
      width: 44px;
    }
  }

  &.isLiked .heartIcon {
    fill: var(--action-button-heart-color);
  }
}
</style>
